import type { FC, MouseEvent } from 'react';

import { FakeLink } from 'components/fake-link/FakeLink';
import { ErrorMessageForm } from 'components/forms/error-message-form/ErrorMessageForm';

type Props = {
  onClick(e: MouseEvent): void;
};

export const EmailInUseError: FC<Props> = ({ onClick }) => (
  <ErrorMessageForm
    titleCaption="Email already in use"
    titleContent={
      <>
        This email address is already tied to the <strong>text|</strong> account.
        <br /> Please contact your administrator to
        <br /> be added manually.
      </>
    }
    link="/"
    buttonText="Log in"
    backToLogin
  >
    <FakeLink onClick={onClick}>&lt; Go back</FakeLink>
  </ErrorMessageForm>
);
